import * as React from 'react'

import { ChevronDownIcon } from 'lucide-react'

import IBasicProps from '~/client/src/shared/interfaces/IBasicProps'

const RIGHT_PADDING = 10

export default function SelectWrapper({ children, className }: IBasicProps) {
  return (
    <div className={`row bare-select-wrapper relative ${className || ''}`}>
      {children}
      <ChevronDownIcon
        size={16}
        style={{ right: RIGHT_PADDING }}
        className="text light absolute unclickable-element"
      />
    </div>
  )
}
